<template>
  <div class="karman-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$f = St · v / d$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>流速 v</label>
            <span class="val">{{ flowVelocity.toFixed(2) }} m/s</span>
          </div>
          <div class="hud-item orange">
             <label>涡旋频率 f</label>
             <span class="val">{{ vortexFreq.toFixed(1) }} Hz</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 500 240" preserveAspectRatio="xMidYMid meet">
          <!-- 背景流线 -->
          <line v-for="i in 8" :key="'l'+i" x1="0" :y1="30+i*20" x2="500" :y2="30+i*20" stroke="#1e293b" stroke-width="1" />

          <!-- 圆柱体 (扰流源) -->
          <circle cx="100" cy="120" r="25" fill="#64748b" stroke="#94a3b8" stroke-width="2" />
          <text x="100" y="125" text-anchor="middle" fill="#fff" font-size="10">圆柱扰流</text>

          <!-- 模拟涡旋 (粒子流轨迹) -->
          <g v-for="v in vortices" :key="v.id" :transform="`translate(${v.x}, ${v.y})`">
             <path d="M -10,0 A 10,10 0 1,1 10,0 A 10,10 0 1,1 -10,0" 
                   fill="none" :stroke="v.color" stroke-width="1.5" stroke-dasharray="2,2" opacity="0.6">
                <animateTransform attributeName="transform" type="rotate" from="0 0 0" to="360 0 0" :dur="v.dur" repeatCount="indefinite" />
             </path>
          </g>
        </svg>

        <div class="physics-caption">
          <strong>物理规律：</strong>在流体中，当流体绕过障碍物时，在特定雷诺数范围内，障碍物两侧会交替脱落方向相反、排列整齐的<strong>涡旋列</strong>。这是造成烟囱、桥梁等建筑物共振破坏的常见原因。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row"><span class="label">调节流体流速 (影响涡旋脱落频率)</span></div>
           <el-slider v-model="flowVelocity" :min="0.5" :max="5.0" :step="0.1" size="small"></el-slider>
        </div>
        
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-wind-power"></i>
           <p><strong>实战物理：</strong>塔科马海峡大桥崩塌正是因为类似的不稳定性引发了结构共振。<strong>观察：</strong>随着你增大流速（滑块），你会发现后端涡旋的排列间距和演变频率会随之提升。这展示了流体与其边界的动态复杂耦合。
           </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'KarmanVortexViz',
  data() {
    return {
      flowVelocity: 1.5,
      vortices: [
        { id: 1, x: 180, y: 100, dur: '1s', color: '#f43f5e' },
        { id: 2, x: 260, y: 140, dur: '1.2s', color: '#10b981' },
        { id: 3, x: 340, y: 100, dur: '1.4s', color: '#f43f5e' },
        { id: 4, x: 420, y: 140, dur: '1.6s', color: '#10b981' }
      ]
    }
  },
  computed: {
    vortexFreq() { return this.flowVelocity * 0.21 * 20; // 粗略 Strouhal 估算
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.karman-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
